<div class="page-container">
    <mat-tab-group dynamicHeight class="pill-tabs background-color" [fitInkBarToContent]="true"  mat-align-tabs="center" >

      <mat-tab label="Perm Calculation">
        <div class="table-container background-color">
          <table mat-table [dataSource]="permCalculationData" class="mat-elevation-z2">

            <ng-container matColumnDef="step">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell"> Step </th>
              <td mat-cell *matCellDef="let element"> {{element.step}} </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell"> Step Name </th>
              <td mat-cell *matCellDef="let element" class="step-name"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="formula">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell"> Formula </th>
              <td mat-cell *matCellDef="let element" class="weglot-ignore formula-cell">
                <code>{{element.formula}}</code>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </mat-tab>

      <mat-tab label="Contract Calculation">
        <div class="table-container background-color">
          <table mat-table [dataSource]="contractCalculationData" class="mat-elevation-z2">

            <ng-container matColumnDef="step">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell"> Step </th>
              <td mat-cell *matCellDef="let element"> {{element.step}} </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell"> Step Name </th>
              <td mat-cell *matCellDef="let element" class="step-name"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="formula">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell"> Formula </th>
              <td mat-cell *matCellDef="let element" class="weglot-ignore formula-cell">
                <code>{{element.formula}}</code>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
         </mat-tab>

    </mat-tab-group>
</div>
